export const handleFlash = () => {
  let hasFlash = false;
  // let flashVersion = 0;

  if (document.all) {
    // @ts-ignore
    const swf = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
    if (swf) {
      hasFlash = true;
      // const VSwf = swf.GetVariable("$version");
      // flashVersion = parseInt(VSwf.split(" ")[1].split(",")[0]);
    }
  } else {
    if (navigator.plugins && navigator.plugins.length > 0) {
      const swf = navigator.plugins["Shockwave Flash"];
      if (swf) {
        hasFlash = true;
        // const words = swf.description.split(" ");
        // for (const value of words) {
        //   if (isNaN(parseInt(value))) continue;
        //   flashVersion = parseInt(value);
        // }
      }
    }
  }
  return hasFlash;
};



// WEBPACK FOOTER //
// ./src/publics/tool/handleFlash.ts